import { Suspense, lazy } from "react";

/**
 * E-BUNDLE-20 — Ladeschranke vor der Fleet-Pulse-Leiste.
 *
 * `OperationsPills` haengt am Flag `sprint29.globalStatusBar` und zieht mit
 * `useDashboardIntelligence`, `useFleetSummary`, `useLiveVehicles` und
 * `useLatestPositions` vier Datenquellen samt Popover-Zubehoer in den Entry.
 * Die Vorbedingung — Flag sichtbar, dazu die Viewport-Entscheidung — prueft
 * die AppShell weiterhin selbst und billig; erst danach laedt diese Schranke
 * das Modul nach. Sichtbar ist die Leiste ohnehin erst nach dem Roundtrip auf
 * GET /v1/feature-flags, also nie beim ersten Paint.
 */
const OperationsPills = lazy(async () => {
  const mod = await import("./GlobalOperationsStatusBar.js");
  return { default: mod.OperationsPills };
});

export function OperationsPillsGate({ wrap = true }: { readonly wrap?: boolean }) {
  return (
    <Suspense fallback={null}>
      <OperationsPills wrap={wrap} />
    </Suspense>
  );
}
